module.exports = __webpack_public_path__ + "img/Weapon_237.fc6cc283.png";